import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import React from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { threePaths } from "./DpInterestMobileTable";
const dphead = [
    "Txn Date",
    "Running Amount (Rs.)",
    "Days",
    "Interest Rate (%)",
    "Interest Amount (Rs.)",
];
const DpInterestTable = (props) => {
    var _a;
    const { reducersData: dpiDetails, commonData: detailsCommonData } = useSelector((state) => state.DpInterest.dpiDetails);
    return (React.createElement(React.Fragment, null, detailsCommonData.loader ? (React.createElement(Common_Shimmer, null)) : detailsCommonData.errorData.isOpen ? (React.createElement(ErrorNotification, { error: detailsCommonData.errorData.error, isOpen: detailsCommonData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })) : detailsCommonData.message.show ? (React.createElement("div", { className: 'error-msg-new-icon' },
        React.createElement(Errormsg, { customMsg: React.createElement("div", { className: 'DMSan_14_700 txt-midnight-blue' },
                "No results found!",
                React.createElement("div", { className: 'DMSanN_14_400 txt_secondary-gray' }, "Try searching for something else")), paths: threePaths, icon: "edel-icon-reports-note" }))) : (React.createElement(Table, null,
        React.createElement("thead", null,
            React.createElement("tr", null, dphead === null || dphead === void 0 ? void 0 : dphead.map((item) => {
                return React.createElement("th", null, item);
            }))),
        React.createElement("tbody", null, (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 :
            _a.map((item) => {
                return (React.createElement("tr", null,
                    React.createElement("td", null, item.transactionDate),
                    React.createElement("td", null, item.runningAmount),
                    React.createElement("td", null, item.days),
                    React.createElement("td", null, item.interestRate),
                    React.createElement("td", null, item.interestAmount)));
            }),
            React.createElement("tr", null))))));
};
export default DpInterestTable;
